// src/polyfills.js
import { Buffer } from 'buffer';
import process from 'process';

// Polyfill Buffer
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

// Polyfill process
if (typeof globalThis.process === 'undefined') {
  globalThis.process = process;
}
if (typeof window !== 'undefined' && !window.process) {
  window.process = process;
}

